module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/paypal-payment-card-62e91f699a55b4c3d8b1e0495fd934f3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/paypal-payment-card.svg
// module id = RaCx
// module chunks = 24